import React, { useEffect, useMemo, useState } from 'react';
import './formularios.scss';
import SidePanel from '../../../../../components/organismsv2/SidePanel/SidePanel';
import Card from '../../../../../components/Atomsv2/Card/Card';
import Input from '../../../../../components/Atomsv2/Input/Input';
import Select from '../../../../../components/Atomsv2/Select/Select';
import Calendar from '../../../../../components/Atomsv2/Calendar/Calendar';
import Status from '../../../../../components/Atomsv2/Status/Status';
import Text from '../../../../../components/Atomsv2/Text/Text';
import Avatar from '../../../../../components/Atomsv2/Avatar/Avatar';
import Button from '../../../../../components/Atomsv2/Button/Button';
import Textarea from '../../../../../components/Atomsv2/Textarea/Textarea';
import useGetDataUser from '../../../../../utilidades/customHooks/useGetDataUser';
import { IntegracionProyectos } from '../../integracion';
import { ToastContainer, useToast } from '../../../../../components/Atomsv2/Toast/Toast';
import Tooltip from '../../../../../components/Atomsv2/Tooltip/Tooltip';
import { useConfirm } from '../../../../../components/Atomsv2/Confirm/Confirm';

const defaultSubtarea = {
    tarea: null, descripcion: null, sprint: null, proyecto: null,
    estatus: { label: 'SIN EMPEZAR', value: 2 }, prioridad: { label: 'MEDIA', value: 2 },
    fecha_ini: null, fecha_fin: null, usuario_asignado: null,
};

const EditarTarea = ({ open, onClose, tarea, data, setData }) => {
    const { toasts, addToast, removeToast } = useToast();
    const userData = useGetDataUser();
    const { confirm, ConfirmDialog } = useConfirm();

    const [dataEdit, setDataEdit] = useState({});
    const [addingSubtarea, setAddingSubtarea] = useState(false);
    const [dataSubtarea, setDataSubtarea] = useState(defaultSubtarea);
    const [editingSubtarea, setEditingSubtarea] = useState(null);

    // Leer SUBTAREAS del objeto actualizado en data.tareas (no del prop estático)
    const tareaActual = useMemo(
        () => data?.tareas?.find(t => t.ID === tarea?.ID) || tarea,
        [data?.tareas, tarea?.ID, tarea]
    );

    const subtareas = useMemo(() => {
        try { return JSON.parse(tareaActual?.SUBTAREAS || '[]'); }
        catch { return []; }
    }, [tareaActual?.SUBTAREAS]);

    useEffect(() => {
        if (!open || !tarea) return;
        setDataEdit({
            id: tarea.ID,
            tarea: tarea.TAREA,
            descripcion: tarea.DESCRIPCION,
            proyecto: tarea.PROYECTO_ID ? { label: tarea.PROYECTO, value: tarea.PROYECTO_ID } : null,
            estatus: tarea.ESTATUS_ID ? { label: tarea.ESTATUS, value: tarea.ESTATUS_ID } : null,
            prioridad: tarea.PRIORIDAD_ID ? { label: tarea.PRIORIDAD, value: tarea.PRIORIDAD_ID } : null,
            sprint: tarea.SPRINT_ID ? { label: tarea.SPRINT, value: tarea.SPRINT_ID } : null,
            fecha_ini: tarea.FECHA_INI?.split('T')[0] || null,
            fecha_fin: tarea.FECHA_FIN?.split('T')[0] || null,
            usuario_asignado: tarea.USUARIO_ASIGNADO_ID
                ? { label: tarea.USUARIO_ASIGNADO_NOMBRE, value: tarea.USUARIO_ASIGNADO_ID, FOTO: tarea.USUARIO_ASIGNADO_FOTO || null }
                : null,
        tarea_bloqueante: (() => {
            try {
                const bl = JSON.parse(tarea.TAREAS_BLOQUEANTES || '[]');
                // vinculo_id: ID del registro en la tabla de tareas bloqueantes
                return bl[0] ? { label: bl[0].TAREA, value: bl[0].ID, vinculo_id: bl[0].ID, fecha_fin: bl[0].FECHA_FIN?.split('T')[0] || null } : null;
            } catch { return null; }
        })(),
        });
    }, [open, tarea]);

    const proyectos = useMemo(() => data.proyecto.map(p => ({ value: p.ID, label: p.PROYECTO })), [data.proyecto]);
    const areas = useMemo(() => data.area.map(p => ({ value: p.ID, label: p.AREA })), [data.area]);
    const sprints = useMemo(() => data.sprints.map(s => ({ value: s.ID, label: s.SPRINT, fecha_ini: s.FECHA_INI, fecha_fin: s.FECHA_FIN })), [data.sprints]);
    const estatus = useMemo(() => data.estatus.map(e => ({ value: e.ID, label: e.ESTATUS })), [data.estatus]);
    const prioridades = useMemo(() => data.prioridades.map(p => ({ value: p.ID, label: p.PRIORIDAD })), [data.prioridades]);

    const estatusPausa = useMemo(() =>
        data.estatus.find(e =>
            String(e.ESTATUS || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes('PAUS')
        ),
        [data.estatus]
    );

    const estatusCompletada = useMemo(() =>
        data.estatus.find(e =>
            ['COMPLET', 'TERMIN', 'FINALIZ'].some(w =>
                String(e.ESTATUS || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(w)
            )
        ),
        [data.estatus]
    );

    const estatusSinEmpezar = useMemo(() =>
        data.estatus.find(e =>
            String(e.ESTATUS || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes('SIN')
        ),
        [data.estatus]
    );

    const tareasParaBloqueante = useMemo(() =>
        (data.tareas || [])
            .filter(t => t.ID !== dataEdit.id && !t.TAREA_PRINCIPAL_ID)
            .map(t => ({ value: t.ID, label: t.TAREA, fecha_fin: t.FECHA_FIN?.split('T')[0] || null })),
        [data.tareas, dataEdit.id]
    );

    const statusTemplate = (d) => { const c = { 1: 'default', 2: 'warning', 3: 'primary', 4: 'neutral', 5: 'success', 6: 'error' }; return <Status severity={c[d.value] || 'primary'}>{d.label}</Status>; };
    const blocanteTemplate = (d) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span className="icon" data-icon="block" style={{ fontSize: 14 }} />
            <span>{d.label}</span>
            {d.fecha_fin && <Text size='extra-small' color='var(--text-color-secondary)'>&nbsp;· entrega: {d.fecha_fin}</Text>}
        </div>
    );
    const prioridadTemplate = (d) => { const c = { 1: 'error', 2: 'warning', 3: 'success' }; return <Status severity={c[d.value] || 'primary'}>{d.label}</Status>; };
    const sprintTemplate = (d) => {
        const fmt = (iso) => new Date(iso).toLocaleDateString('es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' });
        return <div><div>{d.label}</div><Text size='extra-small'>{`${fmt(d.fecha_ini)} - ${fmt(d.fecha_fin)}`}</Text></div>;
    };

    // Devuelve fecha_fin un día después de fecha_ini cuando ésta la supera
    const ajustarFechaFin = (fechaIni, fechaFin) => {
        if (!fechaIni || !fechaFin) return fechaFin;
        if (new Date(fechaIni) > new Date(fechaFin)) {
            const d = new Date(fechaIni);
            d.setDate(d.getDate() + 1);
            return d.toISOString().split('T')[0];
        }
        return fechaFin;
    };

    // La fecha inicio/fin de la tarea principal debe cubrir el rango de todas sus subtareas
    const actualizarRangoPadre = async (padreId, subtareasList) => {
        const inicios = subtareasList.map(s => s.FECHA_INI?.split('T')[0]).filter(Boolean);
        const fines = subtareasList.map(s => s.FECHA_FIN?.split('T')[0]).filter(Boolean);
        if (!inicios.length || !fines.length) return;
        const nuevaFechaIni = inicios.reduce((min, f) => f < min ? f : min);
        const nuevaFechaFin = fines.reduce((max, f) => f > max ? f : max);
        const padre = data.tareas.find(t => t.ID === padreId);
        if (!padre) return;
        if (padre.FECHA_INI?.split('T')[0] === nuevaFechaIni && padre.FECHA_FIN?.split('T')[0] === nuevaFechaFin) return;
        try {
            await IntegracionProyectos.updateTarea({
                id: padre.ID, tarea: padre.TAREA, descripcion: padre.DESCRIPCION,
                id_proyecto: padre.PROYECTO_ID, estatus_id: padre.ESTATUS_ID,
                prioridad_id: padre.PRIORIDAD_ID, id_sprint: padre.SPRINT_ID || null,
                fecha_ini: nuevaFechaIni, fecha_fin: nuevaFechaFin,
                id_usuario_modificacion: userData?.user?.ID,
                id_usuario_asignado: padre.USUARIO_ASIGNADO_ID || null,
            });
        } catch { /* propagación best-effort */ }
        setData(prev => ({
            ...prev,
            tareas: prev.tareas.map(t => t.ID === padreId ? { ...t, FECHA_INI: nuevaFechaIni, FECHA_FIN: nuevaFechaFin } : t)
        }));
        if (dataEdit.id === padreId) {
            setDataEdit(p => ({ ...p, fecha_ini: nuevaFechaIni, fecha_fin: nuevaFechaFin }));
        }
    };

    const submit = async () => {
        if (!dataEdit.tarea || !dataEdit.proyecto || !dataEdit.estatus || !dataEdit.prioridad || !dataEdit.fecha_ini || !dataEdit.fecha_fin) {
            addToast("Por favor, complete todos los campos requeridos", "error", 3000, 'ligth');
            return;
        }
        try {
            await IntegracionProyectos.updateTarea({
                id: dataEdit.id,
                tarea: dataEdit.tarea,
                descripcion: dataEdit.descripcion,
                id_proyecto: dataEdit.proyecto.value,
                estatus_id: dataEdit.estatus.value,
                prioridad_id: dataEdit.prioridad.value,
                id_sprint: dataEdit.sprint?.value || null,
                fecha_ini: dataEdit.fecha_ini,
                fecha_fin: dataEdit.fecha_fin,
                id_usuario_modificacion: userData?.user?.ID,
                id_usuario_asignado: dataEdit.usuario_asignado?.value || null,
            });

            const updated = {
                TAREA: dataEdit.tarea,
                DESCRIPCION: dataEdit.descripcion,
                PROYECTO: dataEdit.proyecto.label,
                PROYECTO_ID: dataEdit.proyecto.value,
                ESTATUS: dataEdit.estatus.label,
                ESTATUS_ID: dataEdit.estatus.value,
                PRIORIDAD: dataEdit.prioridad.label,
                PRIORIDAD_ID: dataEdit.prioridad.value,
                SPRINT: dataEdit.sprint?.label || null,
                SPRINT_ID: dataEdit.sprint?.value || null,
                FECHA_INI: dataEdit.fecha_ini,
                FECHA_FIN: dataEdit.fecha_fin,
                USUARIO_ASIGNADO_NOMBRE: dataEdit.usuario_asignado?.label || null,
                USUARIO_ASIGNADO_ID: dataEdit.usuario_asignado?.value || null,
                USUARIO_ASIGNADO_FOTO: dataEdit.usuario_asignado?.FOTO || null,
            };

            if (tarea.TAREA_PRINCIPAL_ID) {
                // subtarea → actualizar dentro del SUBTAREAS del padre
                const padre = data.tareas.find(t => t.ID === tarea.TAREA_PRINCIPAL_ID);
                const subtareasActualizadas = padre
                    ? JSON.parse(padre.SUBTAREAS || '[]').map(s => s.ID === dataEdit.id ? { ...s, ...updated } : s)
                    : [];
                setData(prev => ({
                    ...prev,
                    tareas: prev.tareas.map(t =>
                        t.ID === tarea.TAREA_PRINCIPAL_ID ? { ...t, SUBTAREAS: JSON.stringify(subtareasActualizadas) } : t
                    )
                }));
                await actualizarRangoPadre(tarea.TAREA_PRINCIPAL_ID, subtareasActualizadas);
            } else {
                setData(prev => ({
                    ...prev,
                    tareas: prev.tareas.map(t =>
                        t.ID === dataEdit.id ? { ...t, ...updated } : t
                    )
                }));

                // Tareas que tienen esta tarea como bloqueante
                const bloqueadas = data.tareas.filter(t => {
                    try { return JSON.parse(t.TAREAS_BLOQUEANTES || '[]').some(b => b.ID === dataEdit.id); }
                    catch { return false; }
                });
                const esCompletada = estatusCompletada && dataEdit.estatus?.value === estatusCompletada.ID;
                if (esCompletada) {
                    // Al completarse, se elimina el vínculo de bloqueo de cada tarea bloqueada
                    for (const tb of bloqueadas) {
                        try {
                            const vinculo = JSON.parse(tb.TAREAS_BLOQUEANTES || '[]').find(b => b.ID === dataEdit.id);
                            if (!vinculo) continue;
                            await IntegracionProyectos.deleteTareaBloqueante({ id: vinculo.ID });
                        } catch { /* propagación best-effort */ }
                    }
                    if (bloqueadas.length > 0) {
                        setData(prev => ({
                            ...prev,
                            tareas: prev.tareas.map(t => {
                                if (!bloqueadas.some(tb => tb.ID === t.ID)) return t;
                                let restantes = [];
                                try { restantes = JSON.parse(t.TAREAS_BLOQUEANTES || '[]').filter(b => b.ID !== dataEdit.id); }
                                catch { restantes = []; }
                                return { ...t, TAREAS_BLOQUEANTES: JSON.stringify(restantes) };
                            })
                        }));
                    }
                } else {
                    for (const tb of bloqueadas) {
                        try {
                            const nuevaFechaIni = dataEdit.fecha_fin;
                            const iniOrig = tb.FECHA_INI?.split('T')[0];
                            const finOrig = tb.FECHA_FIN?.split('T')[0];
                            const diffDias = (iniOrig && finOrig)
                                ? Math.round((new Date(finOrig) - new Date(iniOrig)) / 86400000)
                                : 1;
                            const dFin = new Date(nuevaFechaIni);
                            dFin.setDate(dFin.getDate() + diffDias);
                            const nuevaFechaFin = dFin.toISOString().split('T')[0];
                            await IntegracionProyectos.updateTarea({
                                id: tb.ID, tarea: tb.TAREA, descripcion: tb.DESCRIPCION,
                                id_proyecto: tb.PROYECTO_ID, estatus_id: tb.ESTATUS_ID,
                                prioridad_id: tb.PRIORIDAD_ID, id_sprint: tb.SPRINT_ID || null,
                                fecha_ini: nuevaFechaIni,
                                fecha_fin: nuevaFechaFin,
                                id_usuario_modificacion: userData?.user?.ID,
                                id_usuario_asignado: tb.USUARIO_ASIGNADO_ID || null,
                            });
                        } catch { /* propagación best-effort */ }
                    }
                    if (bloqueadas.length > 0) {
                        const nuevaFechaIni = dataEdit.fecha_fin;
                        setData(prev => ({
                            ...prev,
                            tareas: prev.tareas.map(t => {
                                if (!bloqueadas.some(tb => tb.ID === t.ID)) return t;
                                const iniOrig = t.FECHA_INI?.split('T')[0];
                                const finOrig = t.FECHA_FIN?.split('T')[0];
                                const diffDias = (iniOrig && finOrig)
                                    ? Math.round((new Date(finOrig) - new Date(iniOrig)) / 86400000)
                                    : 1;
                                const dFin = new Date(nuevaFechaIni);
                                dFin.setDate(dFin.getDate() + diffDias);
                                return { ...t, FECHA_INI: nuevaFechaIni, FECHA_FIN: dFin.toISOString().split('T')[0] };
                            })
                        }));
                    }
                }
            }

            addToast("Tarea actualizada", "success", 3000, 'ligth');
            onClose();
        } catch {
            addToast("Error al actualizar la tarea", "error", 3000, 'ligth');
        }
    };

    const submitSubtarea = async () => {
        if (!dataSubtarea.tarea || !dataSubtarea.proyecto || !dataSubtarea.estatus || !dataSubtarea.prioridad || !dataSubtarea.fecha_ini || !dataSubtarea.fecha_fin) {
            addToast("Por favor, complete todos los campos requeridos", "error", 3000, 'ligth');
            return;
        }
        try {
            const res = await IntegracionProyectos.createTarea({
                tarea: dataSubtarea.tarea,
                descripcion: dataSubtarea.descripcion,
                id_proyecto: dataSubtarea.proyecto.value,
                estatus_id: dataSubtarea.estatus.value,
                prioridad_id: dataSubtarea.prioridad.value,
                id_sprint: dataSubtarea.sprint?.value || null,
                fecha_ini: dataSubtarea.fecha_ini,
                fecha_fin: dataSubtarea.fecha_fin,
                id_usuario_creacion: userData?.user?.ID,
                id_usuario_asignado: dataSubtarea.usuario_asignado?.value || null,
                tarea_principal_id: dataEdit.id,
            });

            const newSub = {
                ID: res?.ID || Date.now(),
                TAREA: dataSubtarea.tarea,
                DESCRIPCION: dataSubtarea.descripcion,
                PROYECTO: dataSubtarea.proyecto.label,
                PROYECTO_ID: dataSubtarea.proyecto.value,
                ESTATUS: dataSubtarea.estatus.label,
                ESTATUS_ID: dataSubtarea.estatus.value,
                PRIORIDAD: dataSubtarea.prioridad.label,
                PRIORIDAD_ID: dataSubtarea.prioridad.value,
                SPRINT: dataSubtarea.sprint?.label || null,
                SPRINT_ID: dataSubtarea.sprint?.value || null,
                FECHA_INI: dataSubtarea.fecha_ini,
                FECHA_FIN: dataSubtarea.fecha_fin,
                USUARIO_CREACION_ID: userData?.user?.ID,
                USUARIO_CREACION_NOMBRE: userData?.user?.NOMBRE,
                USUARIO_ASIGNADO_ID: dataSubtarea.usuario_asignado?.value || null,
                USUARIO_ASIGNADO_NOMBRE: dataSubtarea.usuario_asignado?.label || null,
                USUARIO_ASIGNADO_FOTO: dataSubtarea.usuario_asignado?.FOTO || null,
                TAREA_PRINCIPAL_ID: dataEdit.id,
            };

            // Insertar subtarea en el campo SUBTAREAS del padre en el estado
            setData(prev => ({
                ...prev,
                tareas: prev.tareas.map(t =>
                    t.ID === dataEdit.id
                        ? { ...t, SUBTAREAS: JSON.stringify([...JSON.parse(t.SUBTAREAS || '[]'), newSub]) }
                        : t
                )
            }));

            await actualizarRangoPadre(dataEdit.id, [...subtareas, newSub]);

            setDataSubtarea(defaultSubtarea);
            setAddingSubtarea(false);
            
            addToast("Subtarea creada", "success", 3000, 'ligth');
        } catch {
            addToast("Error al crear la subtarea", "error", 3000, 'ligth');
        }
    };

    const handleBloqueante = async (selectedTask) => {
        if (!selectedTask) {
            const vinculoId = dataEdit.tarea_bloqueante?.vinculo_id;
            if (vinculoId) {
                try {
                    await IntegracionProyectos.deleteTareaBloqueante({ id: vinculoId });
                    setData(prev => ({
                        ...prev,
                        tareas: prev.tareas.map(t =>
                            t.ID === dataEdit.id ? { ...t, TAREAS_BLOQUEANTES: JSON.stringify([]) } : t
                        )
                    }));
                    addToast('Tarea desbloqueada correctamente', 'success', 3000, 'ligth');
                } catch {
                    addToast('Error al desbloquear la tarea', 'error', 3000, 'ligth');
                    return;
                }
            }
            setDataEdit(p => ({ ...p, tarea_bloqueante: null }));
            return;
        }
        const ok = await confirm({
            title: '¿Bloquear esta tarea?',
            message: `"${dataEdit.tarea}" quedará bloqueada por "${selectedTask.label}". El estatus cambiará a En pausa y la fecha de inicio se ajustará a la fecha fin de la tarea bloqueante.`,
            icon: 'block',
            confirmText: 'Bloquear',
        });
        if (!ok) return;
        const fechaIniNueva = selectedTask.fecha_fin || null;
        // Conservar el mismo lapso de días entre inicio y fin originales
        const diffDias = (dataEdit.fecha_ini && dataEdit.fecha_fin)
            ? Math.round((new Date(dataEdit.fecha_fin) - new Date(dataEdit.fecha_ini)) / 86400000)
            : 1;
        const fechaFinCalculada = (() => {
            if (!fechaIniNueva) return dataEdit.fecha_fin;
            const d = new Date(fechaIniNueva);
            d.setDate(d.getDate() + diffDias);
            return d.toISOString().split('T')[0];
        })();
        const fechaFinAjustada = fechaFinCalculada;
        const pausaId = estatusPausa?.ID;
        const pausaLabel = estatusPausa?.ESTATUS;
        try {
            // Un vínculo previo debe eliminarse antes de crear el nuevo (clave única en BD)
            if (dataEdit.tarea_bloqueante?.vinculo_id) {
                await IntegracionProyectos.deleteTareaBloqueante({ id: dataEdit.tarea_bloqueante.vinculo_id });
            }
            await IntegracionProyectos.createTareaBloqueante({
                id: dataEdit.id,
                id_bloqueante: selectedTask.value,
            });
            await IntegracionProyectos.updateTarea({
                id: dataEdit.id,
                tarea: dataEdit.tarea,
                descripcion: dataEdit.descripcion,
                id_proyecto: dataEdit.proyecto?.value,
                estatus_id: pausaId,
                prioridad_id: dataEdit.prioridad?.value,
                id_sprint: dataEdit.sprint?.value || null,
                fecha_ini: fechaIniNueva,
                fecha_fin: fechaFinAjustada,
                id_usuario_modificacion: userData?.user?.ID,
                id_usuario_asignado: dataEdit.usuario_asignado?.value || null,
            });
            const tareaBloqueanteData = (data.tareas || []).find(t => t.ID === selectedTask.value)
                || { ID: selectedTask.value, TAREA: selectedTask.label };
            setDataEdit(p => ({
                ...p,
                tarea_bloqueante: { ...selectedTask, vinculo_id: tareaBloqueanteData.ID },
                fecha_ini: fechaIniNueva,
                fecha_fin: fechaFinAjustada,
                estatus: pausaId ? { label: pausaLabel, value: pausaId } : p.estatus,
            }));
            setData(prev => ({
                ...prev,
                tareas: prev.tareas.map(t =>
                    t.ID === dataEdit.id
                        ? { ...t, FECHA_INI: fechaIniNueva, FECHA_FIN: fechaFinAjustada,
                            ESTATUS_ID: pausaId, ESTATUS: pausaLabel,
                            TAREAS_BLOQUEANTES: JSON.stringify([tareaBloqueanteData]) }
                        : t
                )
            }));
            addToast('Tarea bloqueada correctamente', 'success', 3000, 'ligth');
        } catch {
            addToast('Error al bloquear la tarea', 'error', 3000, 'ligth');
        }
    };

    // locked: array de campos que se muestran rellenos pero no editables
    const camposFormulario = (state, setState, locked = []) => {
        const bloquear = (campo, jsx) =>
            locked.includes(campo)
                ? <div style={{ pointerEvents: 'none', opacity: 0.55, width: "100%" }}>{jsx}</div>
                : jsx;
        return (
            <>
                <div className='TareaInformacionProyectos'>
                    
                       
                    {/* {bloquear('area', <Select label="AREA" value={state.area} options={areas}
                        onChange={e => setState(p => ({ ...p, area: e }))}
                        mapper={{ name: 'label', value: 'value' }} />)} */}
                    {bloquear('proyecto', <Select label="PROYECTO" value={state.proyecto} options={proyectos}
                        onChange={e => setState(p => ({ ...p, proyecto: e }))}
                        mapper={{ name: 'label', value: 'value' }} />)}
                    {bloquear('estatus', <Select label="ESTATUS" value={state.estatus} options={estatus}
                        onChange={e => setState(p => ({ ...p, estatus: e }))}
                        mapper={{ name: 'label', value: 'value' }} body={statusTemplate} />)}
                    <Select label="PRIORIDAD" value={state.prioridad} options={prioridades}
                        onChange={e => setState(p => ({ ...p, prioridad: e }))}
                        mapper={{ name: 'label', value: 'value' }} body={prioridadTemplate} />
                    <Select label="ASIGNAR A" value={state.usuario_asignado} options={data?.usuario}
                        onChange={e => setState(p => ({ ...p, usuario_asignado: e }))}
                        mapper={{ name: 'label', value: 'value' }} />
                </div>
                <div className='TareaInformacionProyectos'>
                    {bloquear('fecha_ini', <Calendar label="FECHA INICIO" value={state.fecha_ini}
                        onChange={e => setState(p => ({ ...p, fecha_ini: e }))} />)}
                    {bloquear('fecha_fin', <Calendar label="FECHA FIN" value={state.fecha_fin}
                        onChange={e => setState(p => ({ ...p, fecha_fin: e }))} />)}
                    {bloquear('sprint', <Select label="SPRINT" value={state.sprint} options={sprints}
                        onChange={e => setState(p => ({ ...p, sprint: e }))}
                        mapper={{ name: 'label', value: 'value' }} body={sprintTemplate} />)}
                </div>
                <Textarea
                    value={state.descripcion || ''}
                    onChange={e => setState(p => ({ ...p, descripcion: e.target.value }))}
                    label="DESCRIPCIÓN"
                    placeholder="Agrega una descripción..."
                    rows={4}
                />
            </>
        );
    };
    const tooltipTarea = (sub) => {
        // new Date(iso) interpreta "YYYY-MM-DD" como UTC y desfasa un día en zonas horarias negativas
        const fmt = (iso) => {
            if (!iso) return '—';
            const [y, m, d] = iso.split('T')[0].split('-').map(Number);
            return new Date(y, m - 1, d).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
        };
        const cp = { 1: 'error', 2: 'warning', 3: 'success' };
        const ce = { 1: 'default', 2: 'warning', 3: 'primary', 4: 'neutral', 5: 'success', 6: 'error' };
        return (
            <div className="subtarea-tooltip-body">
                {sub.DESCRIPCION && <p className="stb-desc">{sub.DESCRIPCION}</p>}
                <div className="stb-grid">
                    <span className="stbl">Estatus</span>
                    <Status severity={ce[sub.ESTATUS_ID] || 'primary'}>{sub.ESTATUS}</Status>
                    <span className="stbl">Prioridad</span>
                    <Status severity={cp[sub.PRIORIDAD_ID] || 'primary'}>{sub.PRIORIDAD}</Status>
                    <span className="stbl">Sprint</span>
                    <span className="stbv">{sub.SPRINT || '—'}</span>
                    <span className="stbl">Entrega</span>
                    <span className="stbv">{fmt(sub.FECHA_FIN)}</span>
                    <span className="stbl">Asignado</span>
                    <span className="stbv">{sub.USUARIO_ASIGNADO_NOMBRE?.trim() || '—'}</span>
                </div>
            </div>
        );
    };
   const estatusColores = { 1: 'default', 2: 'warning', 3: 'primary', 4: 'neutral', 5: 'success', 6: 'error' };

    return (
        <>
            <SidePanel open={open} onClose={onClose} className='proyecto-Tarea'
                title="Editar tarea" icon="edit_note"
                subtitle={'Modifica los datos de la tarea'} width="50vw"
            >
                <Card className="tarea-card">
                    <div className="tarea-header">
                        <div className="tarea-author">
                            <Avatar label={userData?.user?.NOMBRE} size="small" />
                            <div className="tarea-author-info">
                                <Text weight={600} className="tarea-author-name">{userData?.user?.NOMBRE}</Text>
                            </div>
                        </div>
                        <Button icon="save" onClick={submit}>Guardar</Button>
                    </div>

                    <Input placeholder="NOMBRE DE LA TAREA" className="tarea-title" label="Tarea"
                        value={dataEdit.tarea || ''}
                        onChange={e => setDataEdit(p => ({ ...p, tarea: e.target.value }))} />

                    {!tarea?.TAREA_PRINCIPAL_ID && (
                        <Select
                            label="BLOQUEAR POR"
                            value={dataEdit.tarea_bloqueante}
                            options={tareasParaBloqueante}
                            onChange={handleBloqueante}
                            mapper={{ name: 'label', value: 'value' }}
                            body={blocanteTemplate}
                            placeholder="Sin tarea bloqueante..."
                        />
                    )}

                    {camposFormulario(dataEdit, setDataEdit, (() => {
                        if (tarea?.TAREA_PRINCIPAL_ID) return ['area', 'proyecto', 'sprint'];
                        if (!dataEdit.tarea_bloqueante) return [];
                        // Desbloquear campos si la tarea bloqueante ya fue completada
                        const tareaBloc = (data.tareas || []).find(t => t.ID === dataEdit.tarea_bloqueante.value);
                        const blocanteCompletada = estatusCompletada && tareaBloc?.ESTATUS_ID === estatusCompletada.ID;
                        return blocanteCompletada ? [] : ['estatus', 'fecha_ini'];
                    })())}

                    {/* Subtareas solo en tareas principales */}
                    {!tarea?.TAREA_PRINCIPAL_ID && (
                        <div className="subtareas-section">
                            <div className="subtareas-header">
                                <label className="icon" data-icon="account_tree" />
                                <Text size='extra-small' weight={600}>SUBTAREAS</Text>
                                {subtareas.length > 0 && <span className="subtareas-count">{subtareas.length}</span>}
                            </div>
                            {subtareas.map(sub => (
                                <Tooltip className={"tooltip-trigger-proyectos-sub-tareas"} key={sub.ID} content={tooltipTarea(sub)}>
                                    <div className="subtarea-row" onClick={() => setEditingSubtarea(sub)}>
                                        <label className="icon" data-icon={sub.ESTATUS_ID === 5 ? 'check_box' : 'check_box_outline_blank'} />
                                        <Text size='extra-small'>{sub.TAREA}</Text>
                                        <Status severity={{ 1: 'error', 2: 'warning', 3: 'success' }[sub.PRIORIDAD_ID] || 'primary'}>
                                            {sub.PRIORIDAD}
                                        </Status>
                                        <Status severity={estatusColores[sub.ESTATUS_ID] || 'primary'}>
                                            {sub.ESTATUS}
                                        </Status>
                                    </div>
                                </Tooltip>
                            ))}
                            <div className="subtarea-add-row" onClick={() => {
                                setDataSubtarea({
                                    ...defaultSubtarea,
                                    proyecto: dataEdit.proyecto,
                                    fecha_ini: dataEdit.fecha_ini,
                                    fecha_fin: dataEdit.fecha_fin,
                                    sprint: dataEdit.sprint,
                                });
                                setAddingSubtarea(true);
                            }}>
                                <label className="icon" data-icon="add" />
                                <span className="subtarea-add-label">Agregar subtarea</span>
                            </div>
                        </div>
                    )}
                </Card>
                <ToastContainer toasts={toasts} removeToast={removeToast} />
            </SidePanel>

            {/* SidePanel para crear subtarea (campos vacíos, igual que crear tarea) */}
            <SidePanel
                open={addingSubtarea}
                onClose={() => { setAddingSubtarea(false); setDataSubtarea(defaultSubtarea); }}
                className='proyecto-Tarea'
                title="Nueva subtarea"
                icon="add_task"
                subtitle={`Subtarea de: ${dataEdit.tarea || ''}`}
                width="50vw"
            >
                <Card className="tarea-card">
                    <div className="tarea-header">
                        <div className="tarea-author">
                            <Avatar label={userData?.user?.NOMBRE} size="small" />
                            <div className="tarea-author-info">
                                <Text weight={600} className="tarea-author-name">{userData?.user?.NOMBRE}</Text>
                            </div>
                        </div>
                        <Button icon="add" onClick={submitSubtarea}>Agregar</Button>
                    </div>
                    <Input placeholder="NOMBRE DE LA SUBTAREA" className="tarea-title" label="Tarea"
                        value={dataSubtarea.tarea || ''}
                        onChange={e => setDataSubtarea(p => ({ ...p, tarea: e.target.value }))} />
                    {camposFormulario(dataSubtarea, setDataSubtarea, ['proyecto', 'sprint'])}
                </Card>
            </SidePanel>

            {/* Panel anidado para editar una subtarea */}
            {editingSubtarea && (
                <EditarTarea
                    open={!!editingSubtarea}
                    onClose={() => setEditingSubtarea(null)}
                    tarea={editingSubtarea}
                    data={data}
                    setData={setData}
                />
            )}
            {ConfirmDialog}
        </>
    );
};
export default EditarTarea;
